import { rest } from 'msw'
import moment from 'moment'
moment.locale('ja')
export default [
  rest.post('/api/v2/get_advertisement_detail', (req, res, ctx) => {
    const data = [
      {
        id: 1,
        title: 'これはテスト',
        type: 0,
        image: 'https://placehold.jp/150x150.png',
        openDate: '1648738800',
        closeDate: '',
        maker: '味の素',
        details: [
          {
            seq: 2,
            type: 'title',
            background: '#9f9cda',
            color: '#5a4646',
            body: 'サブタイトル',
            attribute: [],
          },
          {
            seq: 1,
            type: 'text',
            background: '#bef4c8',
            color: '',
            body:
              '<p>本文テスト  <b>ここは太字 <font color="#de4a4a">ここは太字＋赤字</font></b></p><p><a href="https://mypage-stg.retailstudio.jp/maruilife/11/content/920" target="_blank">リンクが入ります。</a></p><p><br></p>',
            attribute: [],
          },
          {
            seq: 3,
            type: 'image',
            background: '#fe7878',
            color: '',
            body:
              'https://static-stg.retailstudio.jp/assets/contents/910/detail_675be3d77fcf592f0ff324e76d2739be.png',
            attribute: {
              height: '199',
              width: '289',
            },
            url: 'https://mypage-stg.retailstudio.jp/maruilife/11/content',
          },
          {
            seq: 5,
            type: 'quote',
            background: '#fffdd5',
            color: '',
            body:
              '<p>引用テキストです。</p><p><b>ここは太字</b></p><p><font color="#1da6e3">ここは青字</font></p><p><a href="https://mypage-stg.retailstudio.jp/maruilife/11/content/906" target="_blank">ここがリンク</a></p><p>ノーマルテキスト</p>',
            attribute: [],
          },
          {
            seq: 4,
            type: 'image',
            background: '#fe7878',
            color: '',
            body:
              'https://static-stg.retailstudio.jp/assets/contents/910/detail_675be3d77fcf592f0ff324e76d2739be.png',
            attribute: {
              height: '199',
              width: '289',
            },
            url: 'https://mypage-stg.retailstudio.jp/maruilife/11/content',
          },
          {
            seq: 6,
            type: 'quote',
            background: '#fffdd5',
            color: '',
            body:
              '<p>引用テキストです。</p><p><b>ここは太字</b></p><p><font color="#1da6e3">ここは青字</font></p><p><a href="https://mypage-stg.retailstudio.jp/maruilife/11/content/906" target="_blank">ここがリンク</a></p><p>ノーマルテキスト</p>',
            attribute: [],
          },
          {
            seq: 9,
            type: 'text',
            background: '#bef4c8',
            color: '',
            body:
              '<p>本文テスト  <b>ここは太字 <font color="#de4a4a">ここは太字＋赤字</font></b></p><p><a href="https://mypage-stg.retailstudio.jp/maruilife/11/content/920" target="_blank">リンクが入ります。</a></p><p><br></p>',
            attribute: [],
          },
          {
            seq: 7,
            type: 'caption',
            background: '#38f000',
            body: 'キャプションテスト',
            attribute: [],
          },
          {
            seq: 8,
            type: 'embedded',
            background: '#eca8de',
            body: 'https://www.youtube.com/watch?v=PRf02Vgcdgw',
            attribute: {
              title:
                '【ハッキリ言って無限です】ミシュランシェフが教える最高に簡単でおいしい神レシピ「無限ペペたま」フルVerはクラシルアプリで先行公開中！【鳥羽周作の◯◯な料理 vol.25 #おうちでsio】クラシル',
              author_name: 'kurashiru [クラシル]',
              author_url: 'https://www.youtube.com/c/kurashiru',
              type: 'video',
              height: 113,
              width: 200,
              version: '1.0',
              provider_name: 'YouTube',
              provider_url: 'https://www.youtube.com/',
              thumbnail_height: 360,
              thumbnail_width: 480,
              thumbnail_url: 'https://i.ytimg.com/vi/PRf02Vgcdgw/hqdefault.jpg',
              html:
                '<iframe width="200" height="113" src="https://www.youtube.com/embed/PRf02Vgcdgw?feature=oembed" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>',
            },
          },
          {
            seq: 10,
            type: 'products',
            background: '#ffffff',
            body: [
              {
                shopName: '大崎駅前店',
                jan: '4999999999999',
                name: 'エビピラフ',
                image: 'https://placehold.jp/150x150.png',
                price: 128,
                priceSub: 138.25,
                periodStart: moment().add(-1, 'days').unix(),
                periodEnd: '',
                remark: '+30P',
                score: null,
                stock: null,
              },
              {
                shopName: '大崎駅前店',
                jan: '4999999999999',
                name: 'エビピラフ',
                image: 'https://placehold.jp/150x150.png',
                price: 128,
                priceSub: 138.25,
                periodStart: moment().add(-1, 'days').unix(),
                periodEnd: moment().add(1, 'days').unix(),
                remark: '+30P',
                score: null,
                stock: null,
              },
              {
                shopName: '大崎駅前店',
                jan: '4999999999999',
                name: 'エビピラフ',
                image: 'https://placehold.jp/150x150.png',
                price: 128,
                priceSub: 138.25,
                periodStart: moment().add(-3, 'days').unix(),
                periodEnd: moment().add(5, 'days').unix(),
                remark: '+30P',
                score: null,
                stock: null,
              },
              {
                shopName: '大崎駅前店',
                jan: '4999999999999',
                name: 'エビピラフ',
                image: 'https://placehold.jp/150x150.png',
                price: 128,
                priceSub: 138.25,
                periodStart: moment().add(-1, 'days').unix(),
                periodEnd: moment().add(0, 'days').unix(),
                remark: '+30P',
                score: null,
                stock: null,
              },
              {
                shopName: '大崎駅前店',
                jan: '4999999999999',
                name: 'エビピラフ',
                image: 'https://placehold.jp/150x150.png',
                price: 128,
                priceSub: 138.25,
                periodStart: moment().add(-1, 'days').unix(),
                periodEnd: moment().add(1, 'days').unix(),
                remark: '+30P',
                score: null,
                stock: null,
              },
            ],
            attribute: [],
          },
        ],
      },
    ]
    const result = data[0]
    return res(
      ctx.status(200),
      ctx.json({
        error: {
          errorCode: 0,
          errorMessage: '',
          errorMessageDetail: '',
        },
        data: result,
      })
    )
  }),
]
